import Checkbox from "components/Checkbox/Checkbox";

interface EvidenceSelectionCheckboxProps {
    evidenceId: string;
    selectedEvidences: string[];
    onSelectionChange: (evidenceId: string, checked: boolean) => void;
}

export const EvidenceSelectionCheckbox = ({
    evidenceId,
    selectedEvidences,
    onSelectionChange
}: EvidenceSelectionCheckboxProps) => {
    return (
        <Checkbox
            checked={selectedEvidences.includes(evidenceId)}
            className="[&[data-state=checked]]:bg-indigo-500 [&[data-state=checked]]:border-indigo-500 [&[data-state=indeterminate]]:bg-indigo-500 [&[data-state=indeterminate]]:border-indigo-500 border-base-sidebarBorder [&[data-state=unchecked]]:border-base-sidebarBorder"
            onCheckedChange={(checked) => {
                onSelectionChange(evidenceId, checked as boolean);
            }}
        />
    );
};

